import { UserProfile } from '../../user/interfaces';
import { PartnerOrganizationStore } from '../../partnerOrganizations/interfaces';

type ContactsPayload = Pick<
  UserProfile,
  'contacts_emails' | 'contacts_phones' | 'need_profile_review' | 'need_profile_submit'
>;

export const updateNestedContacts = (store: PartnerOrganizationStore, data: ContactsPayload) => {
  if (!store.profile || !data) {
    return store;
  }

  return {
    ...store,
    profile: {
      ...store.profile,
      contacts_emails: data.contacts_emails,
      contacts_phones: data.contacts_phones,
      need_profile_review: data.need_profile_review,
      need_profile_submit: data.need_profile_submit,
    },
  };
};
